import type { GraphicInterface } from '@/types/greenroom/graphics.types';
import type { GraphicItem } from '../components/video-list-graphic.types';
import type { MediaItem } from '@/types/greenroom/media.types';
import type { ContentTemplate, StylePackContentType } from '@/types/stylepacks.types';
import type { Shot } from '@/types/greenroom/shots.types';

const isGraphicInterface = (item: GraphicInterface | MediaItem): item is Required<GraphicInterface> => {
  return 'scale_x' in item && !!item.template_type && !!item.id;
};

const isMediaItem = (item: GraphicInterface | MediaItem): item is Required<MediaItem> => {
  return 'media_data' in item && !!item.template_type && !!item.id;
};

export const toGraphicItem = (stylepackContent: ContentTemplate[], templateTypeToShotMap: Record<string, Shot[]>) => {
  const map = Object.fromEntries(
    stylepackContent.filter((item) => item.provider === 'capsule').map((item) => [item.type, item])
  );

  return (item: GraphicInterface | MediaItem): GraphicItem | undefined => {
    const isGraphic = isGraphicInterface(item);
    const isMedia = isMediaItem(item);
    if (isGraphic || isMedia) {
      const stylepack = map[item.template_type as string];
      if (!stylepack) return;

      const shots = templateTypeToShotMap[stylepack.type];
      if (!shots) return;

      return {
        contentType: stylepack.contentType as StylePackContentType,
        id: item.id,
        thumbnailUrl: item.thumbnail_url,
        name: item.original_name,
        shotTitle: shots?.[0].shot_data?.shotTitle ?? 'Untitled',
        type: item.type,
        videoUrl: item.images, // idk why but this is the video url key
        entityType: isGraphic ? 'graphic' : 'media',
        shots: shots,
      };
    }
  };
};
